// extracted by css-extract-rspack-plugin
export default {"transactionId":"transactionId-QE_mcI"};